import PRODUCT_TYPE from 'Component/Product/Product.config';
import ProductListQuery from 'Query/ProductList.query';
import {
    LINKED_PRODUCTS as SOURCE_LINKED_PRODUCTS,
    LinkedProductsDispatcher as SourceLinkedProductsDispatcher
} from 'SourceStore/LinkedProducts/LinkedProducts.dispatcher';
import { updateLinkedProducts } from 'Store/LinkedProducts/LinkedProducts.action';
import componentLoader from 'Util/componentLoader';

export const LINKED_PRODUCTS = SOURCE_LINKED_PRODUCTS;

export const LinkedProductsPriceDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/LinkedProductsPrice/LinkedProductsPrice.dispatcher'
), 2);
export const LinkedProductsVariantsDispatcher = componentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */
    'Store/LinkedProductsVariants/LinkedProductsVariants.dispatcher'
), 2);
/** @namespace Bodypwa/Store/LinkedProducts/Dispatcher */
export class LinkedProductsDispatcher extends SourceLinkedProductsDispatcher {
    onSuccess(data, dispatch, product_links) {
        const { products: { items = [] } = {} } = data;
        const itemsWithPrice = [];
        const itemsWithVariants = [];
        items.filter((item) => {
            const { attributes } = item;
            const filteredAttributes = attributes.filter((attr) => attr.update_product_preview_image && item.type_id
            === PRODUCT_TYPE.configurable && attr.attribute_options.length > 1);

            if (filteredAttributes.length) {
                itemsWithVariants.push(item.sku);
            }
            itemsWithPrice.push(item.sku);
            return item;
        });
        LinkedProductsVariantsDispatcher.then(
            ({ default: dispatcher }) => {
                dispatcher.handleData(dispatch, {
                    args: {
                        filter: { productsSkuArray: itemsWithVariants }
                    },
                    isPdp: false
                });
            }
        );
        LinkedProductsPriceDispatcher.then(
            ({ default: dispatcher }) => {
                dispatcher.handleData(dispatch, {
                    args: { filter: { productsSkuArray: itemsWithPrice } },
                    isPdp: false
                });
            }
        );
        const linkedProducts = this._processResponse(data, product_links);
        dispatch(updateLinkedProducts(linkedProducts));
    }

    /**
     * Prepare LinkedProducts query
     * @return {Query} ProductList query
     * @memberof LinkedProductsDispatcher
     * @param product_links
     */
    prepareRequest(product_links) {
        const relatedSKUs = product_links.reduce((links, link) => {
            const { linked_product_sku } = link;

            return [...links, `${ linked_product_sku.replace(/ /g, '%20') }`];
        }, []);

        return [
            ProductListQuery.getQuery({
                args: {
                    filter: {
                        productsSkuArray: relatedSKUs
                    }
                },
                notRequireInfo: true
            })
        ];
    }
}

export default new LinkedProductsDispatcher();
